export default __webpack_public_path__ + "115fb1fb678e62dcf0b4ac31a2829dd2.svg";